let clip_a = document.querySelector(".vid_a");

clip_a.addEventListener("mouseover", function (e) {
  clip_a.play();
});

clip_a.addEventListener("mouseout", function (e) {
  clip_a.pause();
});

let clip_b = document.querySelector(".vid_b");

clip_b.addEventListener("mouseover", function (e) {
  clip_b.play();
});

clip_b.addEventListener("mouseout", function (e) {
  clip_b.pause();
});

let clip_c = document.querySelector(".vid_c");

clip_c.addEventListener("mouseover", function (e) {
  clip_c.play();
});

clip_c.addEventListener("mouseout", function (e) {
  clip_c.pause();
});

let clip_d = document.querySelector(".vid_d");

clip_d.addEventListener("mouseover", function (e) {
  clip_d.play();
});

clip_d.addEventListener("mouseout", function (e) {
  clip_d.pause();
});

let clip_e = document.querySelector(".vid_e");

clip_e.addEventListener("mouseover", function (e) {
  clip_e.play();
});

clip_e.addEventListener("mouseout", function (e) {
  clip_e.pause();
});

let clip_f = document.querySelector(".vid_f");

clip_f.addEventListener("mouseover", function (e) {
  clip_f.play();
});

clip_f.addEventListener("mouseout", function (e) {
  clip_f.pause();
});

let clip_g = document.querySelector(".vid_g");

clip_g.addEventListener("mouseover", function (e) {
  clip_g.play();
});

clip_g.addEventListener("mouseout", function (e) {
  clip_g.pause();
});




		